import { useEffect } from "react";

import * as Api from "@/api";
import DeviceFeatures from "@/app/domain/callflow/users/DeviceFeatures";
import DistinctiveRingtones from "@/app/domain/callflow/users/distinctiveRingtones/DistinctiveRingtones";
import LineKeyTemplateAccounts from "@/app/domain/callflow/users/lkta/LineKeyTemplateAccounts";
import Personalization from "@/app/domain/callflow/users/Personalization";
import Phonebooks from "@/app/domain/callflow/users/phonebooks/Phonebooks";
import userReducer from "@/app/domain/callflow/users/userReducer";
import { NEW_USER } from "@/constants/New";
import Avatar from "@/design/components/Avatar";
import SaveIndicator from "@/design/components/SaveIndicator";
import useSave, { SaveState } from "@/utils/hooks/useSave";

import { Card, CardHeader } from "@mui/material";
import PropTypes from "prop-types";

function User({ specs, ...props }) {
  useEffect(() => {
    Promise.all([Api.getLineKeyTemplates(), Api.getDistinctiveRingtones()]);
  }, []);

  const {
    value: user,
    dispatch,
    setSaveState,
    formState,
    allErrors,
    save,
  } = useSave({
    initialValue: NEW_USER,
    reducer: userReducer,
    validator: () => ({}),
    onSubmit: () => Api.storeUser(user),
    onSuccess: () => Promise.resolve(Api.getUsers()),
  });

  // Get user data
  useEffect(() => {
    Promise.resolve(Api.getUser({ id: props.user.id })).then((response) =>
      dispatch({ type: "set", value: response.data.sippeer }),
    );
  }, [dispatch, props.user.id]);

  // Handle changes
  const formHandler = (property, value) => {
    dispatch({ type: property, value });
    setSaveState(SaveState.UNSAVED);
  };

  return (
    <>
      <Card>
        <CardHeader
          avatar={<Avatar text={user.name} />}
          title={user.name || "Unnamed user"}
          subheader={user.exten || "No number set"}
          action={<SaveIndicator formState={formState} errors={allErrors} save={save} />}
          sx={{ containerType: "inline-size" }}
        />
      </Card>
      <DeviceFeatures user={user} formHandler={formHandler} specs={specs} />
      {specs.distinctiveRingtone && <DistinctiveRingtones user={user} dispatch={dispatch} />}
      <Personalization user={user} formHandler={formHandler} specs={specs} />
      {specs.phonebooks > 0 && <Phonebooks user={user} dispatch={dispatch} formHandler={formHandler} />}
      {specs.lineKeys > 0 && <LineKeyTemplateAccounts user={user} dispatch={dispatch} />}
    </>
  );
}

export default User;

User.propTypes = {
  user: PropTypes.object,
  specs: PropTypes.object,
};
